export const clientConstants = {
  GET_ALL_CLIENTS: 'GET_ALL_CLIENTS',
}
